const doc = [({"no":({"js":({"routes":({"admin":({"courses":({"edit":({"the_course_was_saved":"Kurset ble lagret"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;